/** @jsxRuntime classic */ /** @jsxFrag React.Fragment */ /** @jsx createElement */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "renderTooltip_unstable", {
    enumerable: true,
    get: ()=>renderTooltip_unstable
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactPortal = require("@fluentui/react-portal");
const _reactJsxRuntime = require("@fluentui/react-jsx-runtime");
const _reactUtilities = require("@fluentui/react-utilities");
const renderTooltip_unstable = (state)=>{
    const { slots , slotProps  } = (0, _reactUtilities.getSlotsNext)(state);
    return /*#__PURE__*/ (0, _reactJsxRuntime.createElement)(_react.Fragment, null, state.children, state.shouldRenderTooltip && /*#__PURE__*/ (0, _reactJsxRuntime.createElement)(_reactPortal.Portal, {
        mountNode: state.mountNode
    }, /*#__PURE__*/ (0, _reactJsxRuntime.createElement)(slots.content, slotProps.content, state.withArrow && /*#__PURE__*/ (0, _reactJsxRuntime.createElement)("div", {
        ref: state.arrowRef,
        className: state.arrowClassName
    }), state.content.children)));
}; //# sourceMappingURL=renderTooltip.js.map

//# sourceMappingURL=renderTooltip.js.map